import LocalGroceryStoreIcon from "@material-ui/icons/LocalGroceryStore"
import LoyaltyIcon from "@material-ui/icons/Loyalty"
import AttachMoneyIcon from "@material-ui/icons/AttachMoney"
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber"

export const getPuntoVentaSections = () => [
  {
    id: "puntoVenta",
    items: [
      {
        id: "boleteria",
        title: "Boleteria",
        icon: LoyaltyIcon,
        href: "/puntoVenta/boleteria",
      },
      {
        id: "inventario",
        title: "Inventario",
        icon: LocalGroceryStoreIcon,
        href: "/puntoVenta/inventario",
      },
      {
        id: "ingresos",
        title: "Ingresos",
        icon: AttachMoneyIcon,
        href: "/puntoVenta/ingresos",
      },
      {
        id: "cuentas",
        title: "Cuentas B./ C.",
        icon: ConfirmationNumberIcon,
        items: [
          { id: "cajas", title: "Cajas", href: "/puntoVenta/cajas" },
          { id: "bancos", title: "Bancos", href: "/puntoVenta/bancos" },
        ],
      },
    ],
  },
]
